
{
  "labels": {
    "description": "A brief description or summary that highlights the content or purpose."
  },
  "name": {
    "label": "Email Subject"
  }
}
